<template>
  <div style="padding: 0 10px">
    <ScanQuery @onQuery="queryCall" ph="输入发货单号" showRest @rest="restHandle">
      <!-- <el-button type="primary" @click="restHandle">重置</el-button> -->
      <!-- <div class="publicCustomerTagName" v-if="customerTagName">{{ customerTagName }}</div> -->
      <template v-if="customerTagNameList?.length">
          <el-tag type="danger" effect="dark" v-for="item in customerTagNameList" :key="item" v-if="item" style="margin-top: 4px;margin-right:10px">{{ item }}</el-tag>
      </template>
      <el-tag type="danger" effect="dark" v-if="packageInfo.overseasInvFlag === 1" style="margin-top: 4px;">海外备货</el-tag>
      <el-button type="primary" style="margin-left: auto" @click="finishMark">打标完成</el-button>
    </ScanQuery>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="padding-right: 20px">发货信息</span>
        <el-tag v-if="deliveryType != undefined">{{ deliveryTitle }}</el-tag>
      </div>
      <el-empty :image-size="100" v-if="!shipInfo" />
      <el-descriptions :column="3" border v-else>
        <el-descriptions-item label="客户名称">
          {{ shipInfo.customerName }}
        </el-descriptions-item>
        <el-descriptions-item label="快递公司">
          <span style="font-weight: 600;color: #40a9ff">
            {{ shipInfo.forwarder }}
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="发货件数">
          <span style="font-weight: 600;color: #40a9ff">
            {{ shipInfo.deliveryNums }} 件
          </span>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
    <WmsTable :columns="columns" :dataSource="dataSource" :is-pagination="false" :rowClassList="rowClassList">
      <div slot="title" style="margin-right: auto;font-weight: 600">
        <span>
          当前商品种类数量: {{ totalSku }} 种;总共: {{ totalNum }} 个
        </span>
        <!--        亚马逊发货，自动显示亚马逊发货，不可以选择-->
        <span style="margin-left: 20px;font-weight: 600">
          批次号
        </span>
        <div style="display: inline-block;margin-right: 100px">
          <ScanQuery_largeBagMark ph="输入批次号" @onQuery="printQueryCall" style="" />
        </div>
        <template v-if="thirdWarehouseType != 4">
          <span>
            选择标签类型：
          </span>
          <!-- <el-select v-model="labelTemplateId" placeholder="请选择" style="margin-left: 10px" filterable
            @visible-change="printTemOnFoucs($event)"> -->
          <el-select v-model="labelTemplateId" placeholder="请选择" style="margin-left: 10px">
            <el-option v-for="item in printTemList" :key="item.id" :label="item.templateName || item.id"
              :value="item.id">
            </el-option>
          </el-select>
        </template>
        <el-button type="primary" @click="printMarkAll" :disabled="dataSource.every(v => v.needLabel === 0)">
          一键打印
        </el-button>
      </div>
      <template slot="pkgCodeList" slot-scope="{text, record, index}">
        <h4 v-for="item in text" :key="item">{{ item }}</h4>
      </template>
      <template slot="productImgAction" slot-scope="{text, record, index}">
        <el-image style="width: 60px; height: 60px" :src="text" :preview-src-list="[text]">
        </el-image>
      </template>
      <template slot="printAmountAction" slot-scope="{text, record, index}">
        <IptNumber v-model="record.printAmount" unit="张" :disabled="record.needLabel === 0"></IptNumber>
      </template>
      <template slot="action" slot-scope="{text, record, index}">
        <el-button type="primary" @click="printMark(record)" :disabled="record.needLabel === 0">
          打印标签
        </el-button>
        <!-- <el-button type="primary" @click="downloadMark(record)">
          下载标签
        </el-button> -->
      </template>
    </WmsTable>
    <div class="skuTips" v-if="showSkuTips" @click="showSkuTips = ''">
      <div>
        <div v-for="i, index in pkgTips" :key="index">{{ i }}</div>
      </div>
      <div style="color: red;">{{ fnSkuTips }}</div>
    </div>
  </div>
</template>

<script>
import ScanQuery from "@/components/ScanQuery";
import WmsTable from "@/components/WmsTable";
import IptNumber from "@/components/IptNumber";
import { audioPay } from "@/utils/tools";
import { columns } from "@/views/outOfStock/largeBagMark/data";
import { finishMark, taskCodeGetInfo, printListByType, pkgDetail, createMarkOperation, getZozotownTemplate } from "@/apis/outStock";
import { templatePrintById, templatePrintByCode } from "@/utils/print"
import { toPrintZozotown } from "@/utils/printZozotown"
import ImgPreviews from "@/components/ImgPreviews";
import ScanQuery_largeBagMark from "./ScanQuery"
import { test, prod } from "@/const/env"
import {tempJson, a} from './data'

export default {
  name: "LargeBagMark", // 大件打标
  components: {
    ScanQuery,
    WmsTable,
    IptNumber,
    ImgPreviews,
    ScanQuery_largeBagMark
  },
  data() {
    return {
      query: {
        code: ''
      },
      shipInfo: null,
      columns,
      deliveryType: undefined, // 发货类型(0:大件普通 1:大件fba 2:小件 3:次品退货 4:异常退货 5:仓库调拨)
      thirdWarehouseType: 0,
      dataSource: [],
      additions: [],
      pkgPackList: [],
      labelTemplateId: '',
      printTemList: [],
      rowClassList: [],
      totalSku: 0,//商品种类
      totalNum: 0,//商品数量
      labelType: 0,
      showSkuTips: false,
      pkgTips: [],
      fnSkuTips: '',
      zozotownConfig: {},
      tagExtendParams: {},
      customerTagNameList: [],
      packageInfo: {}
    }
  },
  computed: {
    deliveryTitle: function () {
      let text = ['大件FBA', '大件普通', '小件', '次品退货', '异常退货', '仓库调拨'][this.deliveryType]
      if (this.deliveryType == 1) {
        text = { 0: '大件其他', 1: '大件FBA', 2: '大件乐天', 3: '大件SHOPLIST', 4: '大件ZOZOTOWN' }[this.thirdWarehouseType]
      }
      return text
    }
  },
  activated() {
    printListByType({ type: 2 }).then(({ code, data }) => {
      if (code == 0) {
        this.printTemList = data
      }
    })
  },
  methods: {
    queryCall: function (payload) {
      const { code } = payload
      this.query = {
        code: code.trim()
      }
      this.getDetails()
    },
    async printQueryCall(payload) {
      const { code } = payload
      if (this.dataSource.map(item => item.pkgCodeList).flat().every(item => item != code)) {
        this.$message.warning('批次包不正确')
        return false
      }
      let params = {
        pkgCode: code
      }
      pkgDetail(params).then(async ({ code, data }) => {
        if (code === 0) {
          let targetSKU = data.shopProductSku
          let printItem = { ...this.dataSource.filter(item => item.shopProductSku == targetSKU)[0] }
          this.pkgTips = printItem.pkgCodeList
          this.fnSkuTips = printItem.amazonFnsku || printItem.coding
          this.showSkuTips = true
          this.changeDatasource(targetSKU, printItem)
          if (printItem.length == 0) {
            audioPay(`扫描失败`)
            return false
          }
          const num = this.pkgPackList.find(item => item.pkgCode === params.pkgCode)?.totalNums ?? printItem.deliveryNums
          const operation = await createMarkOperation({
            "deliveryTaskCode": this.query.code,
            "nums": num,
            "pkgCodeList": [params.pkgCode ?? code],
            "shopProductSku": targetSKU
          })
          if (!operation.success) {
            this.$message.warning("请求日志失败")
            return
          }
          if(this.packageInfo.transferOverseasFlag === 1 || this.packageInfo.overseasInvFlag === 1) {
            const list = Array(num).fill().map(v => ({
              ...v,
              overseasProductSku: printItem.overseasProductSku,
              overseasProductSkuCode: printItem.overseasProductSkuCode,
              customerName: printItem.customerName
            }))
            templatePrintByCode(this.packageInfo.overseasInvFlag ? '1566705096518250001' : '1566705096518250000', list)
            return 
          }
          if (this.thirdWarehouseType == 4) {
            let Arr = []
            for (let i = 0; i < num; i++) {
              Arr.push({
                ...JSON.parse(printItem.tagContent)[0]
              })
            }
            toPrintZozotown(this.zozotownConfig, Arr, this.tagExtendParams)
            return
          }
          if (this.labelType == 2) {
            let Arr = []
            if (printItem.commodityName) {
              printItem.amazonFnsku = printItem.coding
              printItem.productName = printItem.commodityName
              for (let i = 0; i < num; i++) {
                Arr.push(printItem)
              }

              if (this.packageInfo.labelCode39Customer === 1 && this.packageInfo.thirdWarehouseType === 0) {
                templatePrintByCode('15667050965182504960', Arr)
                return
              }
              templatePrintByCode(test() ? '1567858821837037568' : prod() ? '1566705096518250496' : '1549714506089922560', Arr)
            } else {
              this.$message.warning("无对应三方仓文件")
            }
          } else if (this.labelType == 1) {
            if (printItem.barCodeUrl) {
              window.open(printItem.barCodeUrl)
              // for (let i = 0; i < num; i++) {
              //   window.open(printItem.barCodeUrl)
              // }
            } else {
              this.$message.warning("无对应三方仓文件")
            }
          } else {
            let printData = []
            for (let i = 0; i < num; i++) {
              printData.push(printItem)
            }
            templatePrintById(this.labelTemplateId, printData)
          }
          let that = this
          setTimeout(() => {
            that.showSkuTips = false
          }, 2000);

        }
      })
    },
    changeDatasource(targetSKU, printItem) {
      if (this.dataSource.length > 1) {
        let index = this.dataSource.findIndex(item => item.shopProductSku == targetSKU)
        let oldVal = this.dataSource[0]
        if (oldVal.shopProductSku != printItem.shopProductSku) {
          this.dataSource.splice(index, 1)
          this.dataSource.splice(0, 1)
          this.dataSource = [printItem, ...this.dataSource, oldVal]
        }
      }
      if (!this.rowClassList.some(item => item == targetSKU)) {
        this.rowClassList = [targetSKU]
      }
    },
    restHandle: function () {
      this.query = {
        code: ''
      }
      this.shipInfo = null
      this.dataSource = []
      this.additions = []
      this.customerTagName = []
    },
    getDetails: function () {
      const that = this
      const params = {
        deliveryTaskCode: that.query.code.trim(),
        deliveryStatus: 2
      }
      taskCodeGetInfo(params).then(res => {
        const { code, data = null } = res
        if (code === 0) {
          if (data) {
            audioPay(`扫描成功`)
            const {
              deliveryTaskAdditionalDetailList = [],
              taskDetailList = [],
              deliveryType,
              labelTemplateId,
              thirdWarehouseType,
              labelType = 0,
              pkgPackList = [],
              customerTagNameList
            } = data
            this.packageInfo = data
            this.pkgPackList = pkgPackList
            that.additions = deliveryTaskAdditionalDetailList
            that.deliveryType = deliveryType
            that.thirdWarehouseType = thirdWarehouseType
            that.customerTagNameList = customerTagNameList
            if (thirdWarehouseType == 4) {
              this.getZozotownTemplateApi(data.customerShopId)
              this.tagExtendParams = JSON.parse(data.tagExtendParams)
            }
            that.labelType = labelType
            let totalSku = [], totalNum = 0;
            taskDetailList.forEach((item) => {
              if (totalSku.indexOf(item.productSku) == -1) {
                totalSku.push(item.productSku)
              }
              totalNum += item.deliveryNums
            })
            that.totalSku = totalSku.length;
            that.totalNum = totalNum;
            that.dataSource = taskDetailList.map(item => {
              //   return { ...item, printAmount: thirdWarehouseType == 1 ? item.deliveryNums : 1, id: item.shopProductSku }
              // 大件打标数量全部默认总数量
              return { ...item, printAmount: item.deliveryNums, id: item.shopProductSku }
            })
            if (labelTemplateId) {
              that.labelTemplateId = labelTemplateId
            }
            that.createShipInfo(data)
          } else {
            audioPay(`无需打标`)
          }
        }
      })
    },
    getZozotownTemplateApi(customerShopId) {
      console.log(customerShopId)
      getZozotownTemplate({
        customerShopId: customerShopId,
        thirdWarehouseType: 4
      }).then(res => {
        console.log(res)
        this.zozotownConfig = res.data[0]
      })
    },
    createShipInfo: function (data) {
      const {
        deliveryTaskAddressList = [], // 发货任务-地址信息 根据类型判断 deliveryTaskAddressList[*].addressType 类型(0:收件人地址 1:英文收货地址 2:英文清关地址 3:发件人地址)
        deliveryNums, // 发货总数
        customerName, // 客户姓名
        deliveryTitle, // 	发货标题
        deliveryType, // 	发货类型(0:大件普通 1:大件fba 2:小件单品 3:小件多品 4:次品退货 5:异常退货 6:仓库调拨)
        forwarder, // 承运商
        deliveryTaskAdditionalDetailList
      } = data
      let customsClearanceAddress = ''
      let receiptAddress = ''
      if (deliveryTaskAddressList) {
        deliveryTaskAddressList.forEach((item, index) => {
          // const {
          //   name = '--',
          //   nation = '--',
          //   mobile = '--',
          //   clubCode = '--',
          //   province = '--',
          //   city = '--',
          //   area = '--',
          //   address = '--'
          // } = item
          // const _addressInfo = `收件人：${name},\n国家：${nation},\n省/州：${province},\n城市：${city},\n区/县${area}, \n街道：${address}`
          // if (item.addressType === 0) {
          //   receiptAddress = _addressInfo
          // } else if (item.addressType === 2) {
          //   customsClearanceAddress = _addressInfo
          // }
          if (item.addressType === 0) {
            receiptAddress = deliveryTaskAddressList[index]
          } else if (item.addressType === 2) {
            customsClearanceAddress = deliveryTaskAddressList[index]
          }

        })
      }
      this.shipInfo = {
        customsClearanceAddress, // 清关地址
        customerName, // 客户名称
        deliveryTitle, // 发货名名称
        receiptAddress, // 收件地址
        forwarder, // 承运商
        deliveryNums, // 数量
        deliveryTaskAdditionalDetailList
      }
      console.log('this.shipInfo ', this.shipInfo)
    },
    printMarkAll: function () {
      // if (this.thirdWarehouseType == 1) {
      //   let Arr = []
      //   this.dataSource.forEach(item => {
      //     for (let i = 0; i < item.printAmount; i++) {
      //       Arr.push(item)
      //     }
      //   })
      //   templatePrintById(this.labelTemplateId, Arr)
      // } else if (this.thirdWarehouseType == 2) {
      //   let Arr = []
      //   this.dataSource.forEach(item => {
      //     if (item.commodityName) {
      //       item.amazonFnsku = item.coding
      //       item.productName = item.commodityName
      //       for (let i = 0; i < item.printAmount; i++) {
      //         Arr.push(item)
      //       }
      //     } else {
      //       if (item.barCodeUrl) {
      //         for (let i = 0; i < item.printAmount; i++) {
      //           window.open(item.barCodeUrl)
      //         }
      //       }
      //     }
      //   })
      //   if (Arr.length > 0) {
      //     templatePrintByCode(test() ? '1567858821837037568' : prod() ? '1566705096518250496' : '1549714506089922560', Arr)
      //   } else {
      //     this.$message.warning("无对应乐天文件")
      //   }
      // } else {
      //   this.dataSource.forEach(item => {
      //     if (item.barCodeUrl) {
      //       for (let i = 0; i < item.printAmount; i++) {
      //         window.open(item.barCodeUrl)
      //       }
      //     }
      //   })
      // }

      if(this.packageInfo.transferOverseasFlag === 1 || this.packageInfo.overseasInvFlag === 1) {
        let list = []
        this.dataSource.filter(v => v.needLabel !== 0).forEach(v => {
          list = [
            ...list,
            ...Array(v.printAmount).fill().map(a => ({
              ...a,
              overseasProductSku: v.overseasProductSku,
              overseasProductSkuCode: v.overseasProductSkuCode,
              customerName: v.customerName
            }))
          ]
        })
        templatePrintByCode(this.packageInfo.overseasInvFlag ? '1566705096518250001' : '1566705096518250000', list)
        return 
      }
      if (this.thirdWarehouseType == 4) {
        let Arr = []
        this.dataSource.filter(v => v.needLabel !== 0).forEach(v => {
          let targetItem = { ...v }
          for (let i = 0; i < targetItem.printAmount; i++) {
            Arr.push({
              ...JSON.parse(targetItem.tagContent)[0]
            })
          }
        })
        toPrintZozotown(this.zozotownConfig, Arr, this.tagExtendParams)
        return
      }

      if (this.labelType == 2) {
        let Arr = []
        this.dataSource.filter(v => v.needLabel !== 0).forEach(item => {
          if (item.commodityName) {
            let targetItem = { ...item }
            targetItem.amazonFnsku = item.coding
            targetItem.productName = item.commodityName
            for (let i = 0; i < targetItem.printAmount; i++) {
              Arr.push(targetItem)
            }
          }
        })
        if (Arr.length > 0) {

          if (this.packageInfo.labelCode39Customer === 1 && this.packageInfo.thirdWarehouseType === 0) {
            templatePrintByCode('15667050965182504960', Arr)
            return
          }
          templatePrintByCode(test() ? '1567858821837037568' : prod() ? '1566705096518250496' : '1549714506089922560', Arr)
        } else {
          this.$message.warning("无对应乐天文件")
        }
      } else if (this.labelType == 1) {
        this.dataSource.filter(v => v.needLabel !== 0).forEach(item => {
          if (item.barCodeUrl) {
            window.open(item.barCodeUrl)
            // for (let i = 0; i < item.printAmount; i++) {
            //   window.open(item.barCodeUrl)
            // }
          }
        })
      } else {
        let Arr = []
        this.dataSource.filter(v => v.needLabel !== 0).forEach(item => {
          for (let i = 0; i < item.printAmount; i++) {
            Arr.push(item)
          }
        })
        templatePrintById(this.labelTemplateId, Arr)
      }
    },
    printMark: async function (record) {
      let r = { ...record }
      const operation = await createMarkOperation({
        "deliveryTaskCode": this.query.code,
        "nums": r.printAmount,
        "pkgCodeList": r.pkgCodeList,
        "shopProductSku": r.shopProductSku
      })
      if (!operation.success) {
        this.$message.warning("请求日志失败")
        return
      }
      if(this.packageInfo.transferOverseasFlag === 1 || this.packageInfo.overseasInvFlag === 1) {
        const list = Array(r.printAmount).fill().map(v => ({
            ...record,
            overseasProductSku: record.overseasProductSku,
            overseasProductSkuCode: record.overseasProductSkuCode,
            customerName: record.customerName
          }))
        templatePrintByCode(this.packageInfo.overseasInvFlag ? '1566705096518250001' : '1566705096518250000', list)
        return 
      }
      if (this.thirdWarehouseType == 4) {
        let Arr = []
        for (let i = 0; i < r.printAmount; i++) {
          Arr.push({
            ...JSON.parse(r.tagContent)[0]
          })
        }
        toPrintZozotown(this.zozotownConfig, Arr, this.tagExtendParams)
        return
      }
      if (this.labelType == 2) {
        let Arr = []
        if (r.commodityName) {
          r.amazonFnsku = r.coding
          r.productName = r.commodityName
          for (let i = 0; i < r.printAmount; i++) {
            Arr.push(r)
          }

          if (this.packageInfo.labelCode39Customer === 1 && this.packageInfo.thirdWarehouseType === 0) {
            templatePrintByCode('15667050965182504960', Arr)
            return
          }
          templatePrintByCode(test() ? '1567858821837037568' : prod() ? '1566705096518250496' : '1549714506089922560', Arr)
        } else {
          this.$message.warning("无对应三方仓文件")
        }
      } else if (this.labelType == 1) {
        if (r.barCodeUrl) {
          window.open(r.barCodeUrl)
          // for (let i = 0; i < r.printAmount; i++) {
          //   window.open(r.barCodeUrl)
          // }
        } else {
          this.$message.warning("无对应三方仓文件")
        }
      } else {
        let Arr = []
        for (let i = 0; i < r.printAmount; i++) {
          Arr.push(r)
        }
        templatePrintById(this.labelTemplateId, Arr)
      }
    },
    finishMark: function () {
      const that = this
      const params = {
        deliveryTaskCode: that.query.code
      }
      finishMark(params).then(res => {
        const { code } = res
        if (code === 0) {
          that.$message.success('完成')
          that.restHandle()
        }
      })
    },
    downloadMark(r) {
      if (r.barCodeUrl) {
        let isPDF = r.barCodeUrl.slice(-1, -3).indexOf('PDF' || 'pdf')
        console.log(isPDF)
        window.open(r.barCodeUrl + '?response-content-type=application/pdf')
      }
    }
  }
}
</script>

<style scoped>
.box-card ::v-deep.el-card__header {
  background: #f8f8f8;
}

.box-card {
  margin-bottom: 20px;
}

.clearfix {
  text-align: left;
  font-size: 14px;
  font-weight: bold;
}

.addition__ul--box {
  display: flex;
  justify-content: flex-start;
  align-content: flex-start;
  flex-wrap: wrap;
}

.addition__li--item {
  display: grid;
  /* grid-template-columns: 60px auto;
  grid-template-rows: 60px;
  grid-column-gap: 10px; */
  margin: 10px;
  padding: 8px;
  background: #EBEEF5;
  border-radius: 4px;
}

.skuTips {
  position: fixed;
  top: 50vh;
  right: 10px;
  padding: 20px;
  background-color: #fff;
  font-size: 28px
}
</style>